import axiosConfig from '../axiosConfig';
import CryptoJS from 'crypto-js';

export default {
	/* 
        POST     /api/v1/graphs
    */
	show(data) {
		const companyID = localStorage.getItem('companyID');
		const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(CryptoJS.enc.Utf8);

		const parsed_decrypted = JSON.parse(decrypted);

		if(!parsed_decrypted){
			localStorage.clear();
			window.location = '/';
		}
		else if (parsed_decrypted === 13) {
			return axiosConfig.post('/graphs/gilead', data);
		}else {
			return axiosConfig.post('/graphs', data);
        }
	},
    statsBricks(data) {
        return axiosConfig.post('/graphs/stats_bricks', { stats_tbl: data });
    }
};
